import React from 'react'

function About(){
	return (
		<React.Fragement>
		<h1>About</h1>
		<p>This is the TodoList app v1.0.0 </p>
		</React.Fragement>
		)
}

export default  About